import Axios from "axios";
const baseURL = process.env.VUE_APP_ENDPOINT;
export const api = Axios.create({ baseURL });
export default api;
